import * as Yup from 'yup';


const PersonalitySchema=Yup.object().shape({
	personality_attributes: Yup.array().min(1, "Please select at least one personality attribute").required('Please select at least one personality attribute')
});

export default PersonalitySchema;
